import { useEffect, useState, useRef } from "react";
import { FaTimes, FaEye, FaCloudDownloadAlt, FaRedo } from "react-icons/fa";
import { RiSkipLeftLine } from "react-icons/ri";
import pathconfig from '../../pathconfig.json';
import axios from 'axios';
import moment from 'moment';
import { TfiReload } from "react-icons/tfi";
import { FaRegCopy } from "react-icons/fa";
import { toastSuccess, toastError } from '../toaster';
import packjson from '../../../package.json';
import { useAppContextProvider } from '../../contextapi';

const HistoryTab = (props) => {
    const [historyData, setHistoryData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [fileContent, setFileContent] = useState(null);
    const { userProfile } = useAppContextProvider();
    const [showconfirm, setShowconfirm] = useState(false)
    const [pathId, setpathId] = useState('');
    const [loader, setLoader] = useState(true);
    const { setSidebarClose } = useAppContextProvider();
    const closeBtnRef = useRef(null);
    const modalCloseBtnRef = useRef(null);

    useEffect(() => {
        if (props.leftsidebarvalue === 'history') {
            setLoader(true)
            getHistoryDetails(userProfile.docid);
            // Focus the close button when History tab is opened
            setTimeout(() => {
                if (closeBtnRef.current) {
                    closeBtnRef.current.focus();
                }
            }, 100);
        }
    }, [props.leftsidebarvalue])

    const getHistoryDetails = async (value) => {
        try {
            let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_history_details}`;
            let GetDetailDataString = localStorage.getItem(`${value}_init-getdetails`);
            let GetDetailData = JSON.parse(GetDetailDataString);
            var data = {
                'ArticleGUID': GetDetailData.Articledetails.ArticleGUID,
                'ActivityID': GetDetailData.ActivtyDetails.ActivityID,
                'Proof_Type': GetDetailData.jobdetails.ProofType,
                'docid': value
            }
            const response = await axios.post(url, data);
            let file = [];
            response.data.data.map((item, i) => {
                let path = item.HistoryPath;
                let parts = path.split('/');
                let folderName = parts[3];
                let fileName = parts[4];
                let historyname = `${folderName}_${fileName}`;
                file.push({ 'historyname': historyname });
            })
            const mergedArray = response.data.data.map((item, index) => {
                return { ...item, ...file[index] };
            });
            setHistoryData(mergedArray)
            setLoader(false)
            // toastSuccess('History details loaded successfully');
        } catch (error) {
            console.log(error)
            toastError('Failed to load history details');
        }
    }

    const filepreview = async (filepath) => {
        const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_preview_file}`;
        const data = {
            InputPath: filepath,
        };
        try {
            const isFileexist = await axios.post(url, data);
            if (isFileexist.data) {
                setFileContent(isFileexist.data);
                setShowModal(true); // Show modal when data is loaded
                setTimeout(() => {
                    if (modalCloseBtnRef.current) {
                        modalCloseBtnRef.current.focus();
                    }
                }, 100);
            } else {
                console.error('File does not exist.');
            }
        } catch (error) {
            console.error('Error fetching file:', error);
            toastError('File not found');
        }
    };

    const fileRevole = (pathId) => {
        setpathId(pathId);
        setShowconfirm(true)
    }

    const handleDeleteHistory = () => {
        let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
        let GetDetailData = JSON.parse(GetDetailDataString);
        let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].revokehistory}`;
        var data = {
            'Proof_Type': GetDetailData.jobdetails.ProofType,
            'docid': userProfile.docid,
            'hisID': pathId.hisID,
            'RId': pathId.RId
        }
        axios.post(url, data)
            .then((response) => {
                if (response.data.is_success) {
                    props.reloadData(response.data.is_success)
                    toastSuccess('History revoked successfully');
                }
                getHistoryDetails(userProfile.docid);
                setShowconfirm(false)
            }).catch((error) => {
                console.log(error)
                toastError('Failed to revoke history');
            })
    }

    const fileDownload = async (item) => {
        let urlPath = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].download}`;
        const response = await axios.post(urlPath, {
            blobUrl: item.HistoryPath,
            type: 'application/x-tex'
        }, {
            responseType: 'blob',// Important               
        });
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/x-tex' }));
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = item.historyname;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        toastSuccess(`History file has been successfully downloaded.`);
    }

    const handleRefresh = () => {
        setLoader(true)
        getHistoryDetails(userProfile.docid);
    }

    useEffect(() => {
        if (showModal) {
            const preElement = document.querySelector('.modal-footer pre');
            if (preElement) {
                preElement.scrollTop = 0;
            }
        }
    }, [showModal]);

    return (
        <aside className="history-sidebar" aria-label="History panel">

            <div className={`modal-outer ${showModal ? 'active' : ''}`}>
                <div className="modal modal-zoom-fix">
                    <div className="modal-header">
                        <span>File Preview</span>
                        <div className="header-actions">
                            <button className="copybtn" title="Copy to clipboard" tabIndex={0} ref={modalCloseBtnRef} onClick={() => { navigator.clipboard.writeText(fileContent).then(() => toastSuccess('Content copied to clipboard')).catch(() => toastError('Failed to copy content')); }}><FaRegCopy /></button>
                            <button className="closebtn" title="Close" tabIndex={0} onClick={() => setShowModal(false)}><FaTimes /></button>
                        </div>
                    </div>
                    <div className="modal-body" style={{ maxHeight: '525px' }}>
                        {fileContent ? <pre style={{ whiteSpace: 'pre-wrap', overflow: 'auto', wordBreak: 'break-word', margin: '0', scrollTop: 0 }}>{fileContent}</pre> : 'No content available'}
                    </div>
                </div>
            </div>
            <div className={`modal-outer ${showconfirm ? 'active' : ''}`}>
                <div className="modal confirmation-popup">
                    <div className="modal-header">
                        <h1>Confirm Revert</h1>
                        <button className="modal-close-btn" tabIndex={0} onClick={() => setShowconfirm(false)}><FaTimes /></button>
                    </div>
                    <div className="modal-body">
                        <p style={{ textAlign: 'center', margin: '10px 0' }}>Are you sure you want to revert the article?</p>
                        <p style={{ fontSize: '13px', margin: '0', textAlign: 'center' }}>Note: This action cannot be undone</p>
                    </div>
                    <div className="modal-footer">
                        <button className="primary" tabIndex={0} onClick={handleDeleteHistory}>Yes</button>
                        <button className="outline-secondary" tabIndex={0} onClick={() => setShowconfirm(false)}>No</button>
                    </div>
                </div>
            </div>
            <header className="slider-header">
                <h2>History</h2>
                <div>
                    <button className="refresh-btn" tabIndex={0} onClick={handleRefresh} title="Refresh">
                        <FaRedo />
                    </button>
                    <button
                        className="close-btn"
                        title="Close"
                        tabIndex={0}
                        onClick={() => {
                            setSidebarClose(true);
                            // After closing, return focus to the History tab button
                            setTimeout(() => {
                                const historyTab = document.getElementById('history-tab-btn');
                                if (historyTab) historyTab.focus();
                            }, 0);
                        }}
                        ref={closeBtnRef}
                        onKeyDown={e => {
                            // If Enter or Space, close and focus History tab
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setSidebarClose(true);
                                setTimeout(() => {
                                    const historyTab = document.getElementById('history-tab-btn');
                                    if (historyTab) historyTab.focus();
                                }, 0);
                                return;
                            }
                            // If Tab pressed while loading or no history, move to Image tab
                            if (e.key === 'Tab' && !e.shiftKey && (loader || historyData.length === 0)) {
                                e.preventDefault();
                                const imgBtn = document.getElementById('image-tab-btn');
                                if (imgBtn) imgBtn.focus();
                            }
                        }}
                    >
                        <FaTimes />
                    </button>
                </div>
            </header>
            {loader ?
                <div className="history-loader">
                    <div className='fileupload-loder'><span className="loader"></span></div>
                </div> :
                <div className="history-inner">
                    {historyData.slice().reverse().map((item, i) =>
                        <div className="history-group" key={i}>
                            <h2 tabIndex={0}>
                                <span className="history-number">{(historyData.length - i)}.</span>
                                <>
                                    {moment(item.CreatedOn).format("DD MMMM YYYY - HH:mm:ss")}
                                </>
                            </h2>
                            <p title={item.historyname} aria-label={`${item.historyname}`}>{item.historyname}</p>
                            <div className="history-btn">
                                {(userProfile.role !== 'Author' && userProfile.role !== 'Editor') ?
                                    <button title="Revoke" tabIndex={0} onClick={() => fileRevole(item)}><TfiReload /></button>
                                    :
                                    <button title="Download" tabIndex={0} onClick={() => fileDownload(item)}><FaCloudDownloadAlt /></button>
                                }
                                <button
                                    title="View"
                                    tabIndex={0}
                                    onClick={() => filepreview(item.HistoryPath)}
                                    onKeyDown={e => {
                                        // Only move focus if this is the last visible history item
                                        const visibleHistory = historyData.slice().reverse();
                                        const isLast = i === visibleHistory.length - 1;
                                        if (e.key === 'Tab' && !e.shiftKey && isLast) {
                                            e.preventDefault();
                                            const imgBtn = document.getElementById('image-tab-btn');
                                            if (imgBtn) imgBtn.focus();
                                        }
                                    }}
                                >
                                    <FaEye />
                                </button>
                                {/* Skip to Image Tab button */}
                                <button
                                    title="Skip to Image Tab"
                                    className="skip-to-image-tab"
                                    tabIndex={0}
                                    style={{
                                        width: '1px',
                                        height: '1px',
                                        overflow: 'hidden',
                                    }}
                                    onFocus={e => {
                                        // Make the button visible when focused
                                        e.target.style.position = 'static';
                                        e.target.style.width = 'auto';
                                        e.target.style.height = 'auto';
                                        e.target.style.left = 'auto';
                                        e.target.style.overflow = 'visible';
                                    }}
                                    onBlur={e => {
                                        // Hide again when not focused
                                        e.target.style.position = 'absolute';
                                        e.target.style.width = '1px';
                                        e.target.style.height = '1px';
                                        e.target.style.left = '-9999px';
                                        e.target.style.overflow = 'hidden';
                                    }}
                                    onClick={() => {
                                        const imgBtn = document.getElementById('image-tab-btn');
                                        if (imgBtn) imgBtn.focus();
                                    }}
                                    aria-label="Skip to Image Tab"
                                >
                                    <RiSkipLeftLine />
                                </button>
                            </div>
                        </div>
                    )}
                </div>}
        </aside>
    )
}
export default HistoryTab;